// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application'

import ClipboardController from './clipboard_controller'
application.register('clipboard', ClipboardController)

import Inputs__CurrencyController from './inputs/currency_controller'
application.register('inputs--currency', Inputs__CurrencyController)

import Inputs__TextareaController from './inputs/textarea_controller'
application.register('inputs--textarea', Inputs__TextareaController)

import NewsletterSignupController from './newsletter_signup_controller'
application.register('newsletter-signup', NewsletterSignupController)

import Pilot__AnchorController from './pilot/anchor_controller'
application.register('pilot--anchor', Pilot__AnchorController)

import Pilot__FawController from './pilot/faw_controller'
application.register('pilot--faw', Pilot__FawController)

import Pilot__PlaygroundSelectorController from './pilot/playground_selector_controller'
application.register('pilot--playground-selector', Pilot__PlaygroundSelectorController)

import Pilot__WindowController from './pilot/window_controller'
application.register('pilot--window', Pilot__WindowController)

import Posthog__FeatureFlagController from './posthog/feature_flag_controller'
application.register('posthog--feature-flag', Posthog__FeatureFlagController)

import LawFirmSearchController from './law_firm_search_controller'
application.register('law-firm-search', LawFirmSearchController)

import PlaintiffSearchController from './plaintiff_search_controller'
application.register('plaintiff-search', PlaintiffSearchController)

import SubscriptionPaymentDateController from './subscription_payment_date_controller'
application.register('subscription-payment-date', SubscriptionPaymentDateController)
